import React, { useState } from 'react'
import { Button, DatePicker, Form } from 'antd'
import dayjs from 'dayjs';
import { SearchOutlined } from '@ant-design/icons'
import { GetHistorical, GetHistoricalBunker } from '../../../Api/getData';
import { useSearchParams } from 'react-router-dom';

const { RangePicker } = DatePicker;

const StartRange = () => {
    // Ambil tanggal hari ini
    const startOfDay = dayjs().startOf('day'); // Mulai hari ini jam 00:00:00
    const formattedDateTime = startOfDay.format('YYYY-MM-DD HH:mm:ss.SSS');
    return formattedDateTime;
};

// EndRange: Waktu saat ini
const EndRange = () => {
    const currentDate = dayjs();
    const formattedDateTime = currentDate.format('YYYY-MM-DD HH:mm:ss');
    return formattedDateTime;
};

const FilterRD = ({ onData, onDataToleransi, onLoading }) => {
    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") ? searchParams.get("KodeCabang") : "SGM";
    const ShipCode = searchParams.get("ShipCode") ? searchParams.get("ShipCode") : "G2008";

    // const [loadings, setLoadings] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();

    const onSubmit = async (values) => {

        const { RangeDate } = values;

        const startDateRange = RangeDate ? dayjs(RangeDate[0]).format('YYYY-MM-DD HH:mm:ss') : StartRange();
        const endDateRange = RangeDate ? dayjs(RangeDate[1]).format('YYYY-MM-DD HH:mm:ss') : EndRange();

        try {
            setIsLoading(true);
            onLoading(true);
            // const response = await getHistoryCal(startDateRange, endDateRange, onDataToleransi[0], onDataToleransi[1]);
            // const response = await GetHistorical(KodeCabang, ShipCode, startDateRange, endDateRange, onDataToleransi[0], onDataToleransi[1]);
            const [response] = await GetHistoricalBunker({
                AccountId: KodeCabang,
                ObjectCode: ShipCode,
                StartDate: startDateRange,
                EndDate: endDateRange,
            });
            onData(response);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
            onLoading(false);
        }
    }

    return (
        <div>
            <Form
                layout="vertical"
                // layout="inline"
                onFinish={onSubmit}
                form={form}
                initialValues={{
                    'RangeDate': [dayjs(StartRange()), dayjs(EndRange())]
                }}
            >
                <div className="analytics-date-filter">
                    <Form.Item
                        name="RangeDate" label="Date Range"
                    >
                        <RangePicker
                            popupClassName="analytics-date-popup"
                            showTime={{
                                format: 'HH:mm:ss',
                            }}
                            format="YYYY-MM-DD HH:mm:ss"
                            disabled={isLoading}
                        />
                    </Form.Item>
                    <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={isLoading}>Apply</Button>
                </div>
            </Form >
        </div>
    )
}

export default FilterRD
